import React from "react";
import { ThemeReportData } from '../../../amorg-common';
import { SurveySegment } from '../../../amorg-common';
import { Survey } from '../../../amorg-common';
import { QuestionSummaryPanel } from "./QuestionSummaryPanel";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { P } from "../../../designSystem/typography/Body";
import { H3 } from "../../../designSystem/typography/Heading";

type ThemePanelProps = {
    survey: Survey,
    siteId:string,
    themes: ThemeReportData[],
    segmentFilter: SurveySegment[][],
    showComments:boolean,
}
export function ThemePanel(props: ThemePanelProps): JSX.Element {

    return (
        <>
            {props.themes.map(theme =>
                <ThemeDetails key={theme.theme} theme={theme} {...props} />
            )}
        </>
    );
}

type ThemeDetailsProps = {
    siteId:string,
    survey:Survey,
    theme: ThemeReportData,
    segmentFilter: SurveySegment[][],
    showComments:boolean,
}
function ThemeDetails(props: ThemeDetailsProps): JSX.Element
{
    return (
        <QuestionSummaryPanel
            siteId={props.siteId}
            survey={props.survey}
            header={
                <Flex flexDirection="column">
                    <H3>{props.theme.theme}</H3>
                    <P>
                        Temaet indholder {props.theme.questionData.length} spørgsmål, der i alt er blevet besvaret {props.theme.selections.totalSelections} gange.
                    </P>
                </Flex>
            }
            summaryStats={props.theme.selections}
            questions={props.theme.questionData}
            segmentFilter={props.segmentFilter}
            showComments={props.showComments} />
    );
}